import React from "react";

export const NowTrending = () => {
  return (
    <>
      <div>
        <img
          src="https://static.thcdn.com/images/small/webp/widgets/208-us/41/Top_Ten_Brands-055041.png"
          alt="prodv"
        />
        <h6>Top Ten Brands</h6>
      </div>
      <div>
        <img
          src="https://static.thcdn.com/images/small/webp/widgets/208-us/56/Travel_Size-050756.png"
          alt="prodv"
        />
        <h6>Travel Size</h6>
      </div>
      <div>
        <img
          src="https://static.thcdn.com/images/small/webp/widgets/208-us/15/Self_Tanner-070615.jpg"
          alt="prodv"
        />
        <h6>Self Tanner</h6>
      </div>
      <div>
        <img
          src="https://static.thcdn.com/images/small/webp/widgets/208-us/23/Site_294x368-080123.png"
          alt="prodv"
        />
        <h6>Best Skin Care Beauty Products</h6>
      </div>
    </>
  );
};
